import * as React from "react";
const SvgFiRrFaceZipper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-zipper_svg__a)">
      <path
        fill="#062147"
        d="M8.5 11a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 11m7-3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12c1.921 0 3.756-.44 5.455-1.309a1 1 0 0 0-.91-1.782A9.9 9.9 0 0 1 12 21.999c-5.514 0-10-4.486-10-10S6.486 2 12 2s10 4.486 10 10c0 .611-.056 1.223-.165 1.819a1 1 0 0 0 1.967.361c.132-.715.198-1.449.198-2.181C24 5.383 18.617 0 12 0M6 15v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0m4 3a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m2-3v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0m3 0v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0m4.978 1.34-.565-.251a1.002 1.002 0 0 0-1.331 1.306c1.146 2.66 1.379 2.893 1.505 3.019.39.39.902.585 1.414.585s1.024-.195 1.414-.585c.78-.78.78-2.048 0-2.828-.251-.251-.708-.485-2.437-1.246"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-zipper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceZipper;
